module.exports = __webpack_public_path__ + "img/pen-line.dfe0e0c9.svg";